import { Component, OnInit } from '@angular/core';
import { NetworkStatusService } from '../services/network-status.service';

@Component({
    selector: 'app-network-status',
    template: `
		<div *ngIf="!isOnline && !isClosed" class="network-status">
			Vous êtes hors ligne. S'il vous plait, vérifiez votre connexion internet.
			<button (click)="close()" class="close-btn">X</button>
		</div>
	`,
    styles: [
        `
			.network-status {
				position: fixed;
				bottom: 0;
				left: 0;
				width: 100%;
				background-color: #fef3f6;
				color: #f31653;
				text-align: center;
				padding: 10px;
				z-index: 1000;
			}
			.close-btn {
				background: none;
				border: none;
				color: #f31653;
				font-size: 16px;
				margin-left: 20px;
				cursor: pointer;
			}
			.close-btn:hover {
				color: #ccc;
			}
		`
    ],
    standalone: false
})
export class NetworkStatusComponent implements OnInit {
	isOnline: boolean = true;
	isClosed: boolean = false;

	constructor(private networkStatusService: NetworkStatusService) {}

	ngOnInit() {
		this.networkStatusService.online$.subscribe(status => {
			this.isOnline = status;
			if (status) {
				this.isClosed = false;
			}
		});
	}

	close() {
		this.isClosed = true;
	}
}
